import './card-setting.scss';

export default () => {

};
